import { useQuery } from '../useQuery';
import { getTask } from '@dispatch/shared/services';
import { TaskInclude } from '@dispatch/shared/types';

export const useGetTask = (
  taskId: string,
  resourceId?: string,
  include: TaskInclude[] = []
) => {
  // Prefix invalidation of ['task'] / ['task', taskId] still matches this key.
  const { data, status, refetch } = useQuery(
    ['task', taskId, resourceId, include],
    () => getTask(taskId, resourceId, include)
  );

  return {
    task: data,
    taskStatus: status,
    fetchTask: refetch,
  };
};
